import React, { Component } from "react";
import { Modal, Form, Row, Col, Button, Table, Tooltip } from "antd";
import PessoasPage from "../pages/PessoasPage";
import ProdutosPage from "../pages/ProdutosPage";
import FichaFinanceiraPage from "../pages/FichaFinanceiraPage";
import CtasPagarRecPage from "../pages/CtasPagarRecPage";
import VendasPage from "../pages/VendasPage";
import CondicionaisPage from "../pages/CondicionaisPage";
import CaixasPage from "../pages/CaixasPage";
import axios from "axios";
import numeral from "numeral";
import "./Form.css";
import "../pages/Pages.css";
import { getUsuario } from "../utils/LoginManager";

const { Column } = Table;
const ButtonGroup = Button.Group;

export default class ModalPadraoForm extends Component {
  state = {
    listaRegistros: [],
  };


  componentDidUpdate(propsAnterior) {
    if (this.props.telaModal !== propsAnterior.telaModal) {
      this.setState({ listaRegistros: [] })
      if (this.props.telaModal === 'pagtos') {
        this.getPagtos(this.props.valorTotal);
      }
    }
    if (this.props.registroSelecionadoCC !== propsAnterior.registroSelecionadoCC) {
      this.setState({ listaRegistros: [] })
      if (this.props.telaModal === 'CC') {
        this.getCartaCorrecao(this.props.registroSelecionadoCC);
      }
    }
  }

  componentDidMount() {
    const usuario = getUsuario();
    this.setState({ usuario });
  }

  getPagtos = (valorTotal) => {
    this.setState({ carregando: true, listaRegistros: [] })
    axios.get('/condPagto/lista', {
    }).then(response => {
      const { data } = response;
      const listaRegistros = data.map(regList => {
        return {
          cp_idf: regList.cp_idf,
          cp_codigo: regList.cp_codigo,
          cp_descricao: regList.cp_descricao,
          cp_qtde_parc: regList.cp_qtde_parc,
          vlrParc: (parseFloat(valorTotal) / parseFloat(regList.cp_qtde_parc)).toFixed(2),
        }
      });
      this.setState({
        listaRegistros,
        carregando: false,
      })
    }).catch(error => {
      console.error(error.response);
      this.setState({
        carregando: false,
      })
    })
  }

  getCartaCorrecao = (registro) => {
    this.setState({ carregando: true, listaRegistros: [] })
    axios.get('/notas_fiscais/listaCC', {
      params: {
        idf: registro.nf_idf
      }
    }).then(response => {
      this.setState({
        listaRegistros: response.data,
        carregando: false,
      })
    }).catch(error => {
      console.error(error.response);
      this.setState({
        carregando: false,
      })
    })
  }

  onImprimirCCClick = (registro) => {
    this.setState({ carregando: true });
    const file_url = 'https://api.fastgestor.plenasistemas.inf.br/image/emp' + this.state.usuario.emp_codigo + '/pdf/cc' + registro.nfcc_numero + this.props.registroSelecionadoCC.nf_chave + '.pdf';
    window.open(file_url, '_blank')
    this.setState({ carregando: false });
  };




  renderValor = (vlr) => {
    return (
      <span> {numeral(parseFloat(vlr)).format('0,000.00')} </span>
    );
  };

  renderAcoes = (text, registro) => {
    return (
      <ButtonGroup size="small">
        <Tooltip title="Imprimir CC">
          <Button type="primary" size="small" onClick={() => this.onImprimirCCClick(registro)} icon="printer" />
        </Tooltip>
      </ButtonGroup>
    );
  };



  render() {
    const { onFecharClick, visivel, telaModal } = this.props;
    const { listaRegistros, carregando } = this.state;

    // console.log('ModalPadraoForm.this.props', this.props);
    // console.log('ModalPadraoForm.this.state', this.state);

    return (
      <Modal
        title={telaModal === 'pagtos' ? "Opções de Pagamento" : null}
        visible={visivel}
        destroyOnClose
        onCancel={onFecharClick}
        footer={null}
        width={telaModal === 'pagtos' || telaModal === 'receber' ? "60%" : telaModal === 'CC' ? "30%" : "80%"}
        style={{ top: 10 }}
      >
        <div>
          <Row style={{ marginBottom: -20 }}>
            {telaModal === 'pessoas' ? (
              <PessoasPage tipoTela="" />
            ) : null}

            {telaModal === 'clientes' ? (
              <PessoasPage tipoTela="C" />
            ) : null}

            {telaModal === 'fornecedores' ? (
              <PessoasPage tipoTela="F" />
            ) : null}

            {telaModal === 'transportadoras' ? (
              <PessoasPage tipoTela="T" />
            ) : null}

            {telaModal === 'produtos' ? (
              <ProdutosPage />
            ) : null}

            {telaModal === 'fichaFinanc' ? (
              <FichaFinanceiraPage />
            ) : null}

            {telaModal === 'ctasPagarRec' ? (
              <CtasPagarRecPage />
            ) : null}

            {telaModal === 'vendas' ? (
              <VendasPage />
              // <VendasPage tipoTela="V" />
            ) : null}

            {telaModal === 'condicionais' ? (
              <CondicionaisPage />
            ) : null}

            {telaModal === 'resumoCaixa' ? (
              <CaixasPage />
            ) : null}

            {telaModal === 'pagtos' ? (
              <div style={{ marginBottom: 10 }}>
                < Table
                  pagination={false}
                  loading={{
                    spinning: carregando,
                    tip: 'Carregando. Aguarde...',
                    size: "large"
                  }}
                  dataSource={listaRegistros}
                  rowKey={(registro => registro.cp_idf)}
                >
                  <Column
                    key="cp_codigo"
                    dataIndex="cp_codigo"
                    title="Código"
                    width={80}
                    align="center"
                    className="listaCadastro"
                  />
                  <Column
                    key="cp_descricao"
                    dataIndex="cp_descricao"
                    title="Descrição"
                    width={200}
                    align="left"
                    className="listaCadastro"
                  />
                  <Column
                    key="cp_qtde_parc"
                    dataIndex="cp_qtde_parc"
                    title="Qtde Parcelas"
                    width={70}
                    align="center"
                    className="listaCadastro"
                  />
                  <Column
                    key="vlrParc"
                    dataIndex="vlrParc"
                    title="Valor / Parcela"
                    render={this.renderValor}
                    width={70}
                    align="right"
                    className="listaCadastro"
                  />
                </Table>
              </div>
            ) : null}

            {telaModal === 'CC' ? (
              <div style={{ marginBottom: 20 }}>
                <span className="tituloPage">Lista de Cartas de Correção</span>
                <div className="divider-page1" />

                < Table
                  pagination={false}
                  loading={{
                    spinning: carregando,
                    tip: 'Carregando. Aguarde...',
                    size: "large"
                  }}
                  dataSource={listaRegistros}
                  rowKey={(registro => registro.nfcc_idf)}
                >
                  <Column
                    key="nfcc_numero"
                    dataIndex="nfcc_numero"
                    title="Numero"
                    width={80}
                    align="center"
                    className="listaCadastro"
                  />
                  <Column
                    key="nfcc_texto"
                    dataIndex="nfcc_texto"
                    title="Descrição"
                    width={200}
                    align="left"
                    className="listaCadastro"
                  />
                  <Column
                    key="acoes"
                    title="."
                    render={this.renderAcoes}
                    width={5}
                    align="center"
                    className="listaCadastro"
                  />
                </Table>
              </div>
            ) : null}

          </Row>
          <Row style={{ marginBottom: 20 }}>
            <div className="divider-page1" />
            <Col xs={24} style={{ marginTop: -10 }}>
              <Button
                htmlType="button"
                onClick={onFecharClick}
                className="btn-fechar"
              >
                Fechar
              </Button>
            </Col>
          </Row>
        </div>
      </Modal >
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ModalPadraoForm.js